<template>
  <div>
    <div
      v-if="retornaSite() == '7live'"
      id="frameVideo"
      style="position: relative"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'ms' ? 'block' : 'none',
      }"
    >
      <video
        id="msPlayVideo"
        autoplay
        controls
        playsinline
        style="display: none; height: 100%; max-height: 100%"
        :muted="audioMudo"
      ></video>
    </div>
    <div id="frameMessageRemote" class="bg-white mt-5 m-5 p-5 rounded">
      <h4 class="text-dark text-center">No stream at the moment</h4>
      <h5 class="text-secondary text-center">Source config...</h5>
      <div class="progress">
        <div
          class="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          aria-valuenow="100"
          aria-valuemin="0"
          aria-valuemax="100"
          style="width: 100%"
        ></div>
      </div>
      <h5 class="text-secondary text-center mt-3">Please wait</h5>
    </div>
    <div v-if="!item.erro">
      <div
        v-if="item.evento && hideSofaScore == false && item.evento.sofaScoreId"
      >
        <iframe
          width="100%"
          height="120"
          :src="
            'https://widgets.sofascore.com/pt-BR/embed/attackMomentum?id=' +
            item.evento.sofaScoreId +
            '&widgetBackground=White'
          "
          frameborder="0"
          scrolling="no"
          style="padding: 5px"
        ></iframe>
      </div>
      <div
        v-if="
          item.evento && hideWilliamHill == false && item.evento.williamHillId
        "
      >
        <iframe
          width="100%"
          height="330"
          frameborder="0"
          scrolling="no"
          :src="
            'https://sports.whcdn.net/scoreboards/app/football/index.html?eventId=' +
            william(item.evento.williamHillId) +
            '&sport=football&locale=pt-pt'
          "
        ></iframe>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <span
        v-if="item.evento && item.evento.sofaScoreId"
        style="cursor: pointer"
        class="badge badge-primary"
        @click="hideSofaScore = !hideSofaScore"
        :class="{
          'badge-primary': hideSofaScore,
          'badge-success': !hideSofaScore,
        }"
        >Sofa Score</span
      >
      <span
        v-if="item.evento && item.evento.williamHillId"
        style="cursor: pointer"
        class="badge ml-1"
        :class="{
          'badge-primary': hideWilliamHill,
          'badge-success': !hideWilliamHill,
        }"
        @click="hideWilliamHill = !hideWilliamHill"
        >William Hill</span
      >
    </div>
    <i
      v-if="retornaSite() == '7live'"
      class="d234fdsa2"
      :style="{ top: markTop + 'px' }"
      >{{ markText }}</i
    >
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import { apiOpenVidu } from "@/services/apiOpenVidu.js";
import { apiAnt } from "@/services/apiAnt.js";
import { apiFlashphoner } from "@/services/apiFlashphoner.js";
import { apiMS } from "@/services/apiMS.js";

var viewEventoOpen;

export default {
  name: "ViewEvento2",
  components: {},
  props: {
    propSofaScore: { type: Boolean, default: true },
  },
  data: function () {
    return {
      item: {
        evento: null,
        erro: false,
        token: "",
        erroMensagem: "",
      },
      clean: true,
      markTop: 0,
      markText: "",
      hideSofaScore: true,
      hideWilliamHill: true,
    };
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    async carregarItem1(id) {
      console.log(id);
    },
    async carregarItem(id) {
      var parametros = "";

      if (this.$route.query.canal) {
        parametros = "?canal=" + this.$route.query.canal;
      }

      const response = await api.get("/evento/view/" + id + parametros);

      //* Verifica se econtrou
      if (response.data.erro == false && response.data.itens.length > 0) {
        viewEventoOpen = response.data.itens[0];

        if (this.$route.query.canal) {
          document.title =
            "(" + this.$route.query.canal + ") " + viewEventoOpen.nome;
        } else {
          document.title = viewEventoOpen.nome;
        }

        this.item.evento = viewEventoOpen;
        this.item.evento.servidorTipo = this.item.evento.servidorTipo
          ? this.item.evento.servidorTipo
          : "openvidu";
        this.item.erro = false;

        if (this.item.evento.servidorTipo == "openvidu") {
          apiOpenVidu.entrarSessaoB(viewEventoOpen);
        } else if (this.item.evento.servidorTipo == "ant") {
          apiAnt.view(this.item.evento);
        } else if (this.item.evento.servidorTipo == "sh") {
          apiFlashphoner.initStream();
          apiFlashphoner.connectPlay(
            viewEventoOpen.key,
            this.item.evento,
            this.item.evento.canal
          );
        } else if (this.item.evento.servidorTipo == "ms") {
          apiMS.setUrl(this.item.evento.servidor);
          apiMS.setToken(this.item.evento.msToken);
          await apiMS.connect({ subscribe: true });
        }
      } else {
        this.item.erro = true;
        this.item.erroMensagem = response.data.mensagem;
      }
    },
    async sessionView() {
      var body = {
        token: viewEventoOpen.sessaoView,
      };

      try {
        await api.put("/sessaoView", body);
      } catch (error) {
        console.log(error);
      }
    },
    william(id) {
      return id.replace("OB_EV", "");
    },
    getView() {
      if (this.$route.query.view && this.$route.query.view == "clean") {
        return false;
      }

      return true;
    },
    apiFlashphoner() {
      return apiFlashphoner;
    },
    fullScreen() {
      if (!document.fullscreenElement) {
        document.getElementById("frameVideo").requestFullscreen();
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    },
  },
  mounted() {
    document.body.style.backgroundColor = "black";
    document.body.style.overflow = "hidden";
    document.getElementById("app").style["margin-top"] = "0";
    this.carregarItem(this.$route.params.id);
    document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });
    //this.entrar();

    setInterval(() => {
      this.sessionView();
    }, 15000);

    if (this.retornaSite() == "7live") {
      setInterval(() => {
        this.markTop = this.markTop + 50;

        if (this.markTop > window.innerHeight) {
          this.markTop = 0;
        }
      }, 30000);

      this.markText = this.$sessao.usuario.email;
    }
  },
  computed: {
    audioMudo: function () {
      return (
        this.$sessao.usuario.tipoUsuario == "Administrador" ||
        this.$sessao.usuario.tipoUsuario == "Apresentador"
      );
    },
  },
};
</script>

<style>
video {
  width: 100%;
  height: auto;
}
.d234fdsa1 {
  position: relative;
  left: 3%;
  top: 3%;
  color: white;
  animation: 30s d9df922f0d1 infinite;
}
.d234fdsa2 {
  position: absolute;
  color: white;
  animation: 60s d9df922f0d1 infinite;
  opacity: 0.5;
}
/* center */
.d234fdsa3 {
  position: fixed;
  top: 5%;
  left: 50%;
  color: white;
  animation: 60s d9df922f0d12 infinite;
  opacity: 0.6;
  transform: translate(-50%, -50%);
}
@keyframes d9df922f0d1 {
  0% {
    left: 3px;
    opacity: 0.5;
  }
  25% {
    opacity: 0;
  }
  50% {
    right: 3px;
    opacity: 0.5;
  }
  75% {
    opacity: 0;
  }
}
@keyframes d9df922f0d {
  0% {
    left: 3%;
    top: 3%;
  }
  25% {
    left: 87%;
    top: 3%;
  }
  50% {
    left: 87%;
    top: 87%;
  }
  75% {
    left: 3%;
    top: 87%;
  }
  100% {
    left: 3%;
    top: 3%;
  }
}
</style>
